<template>
  <div class="affiliate-notice-notification-config">
    <el-row>
      <el-col>
        <p>成果の発生、または、報酬の確定があった際に指定のメールアドレスに通知を入れることができます。</p>
        <table class="af-pop">
          <tr>
            <th>成果発生（新規ユーザー獲得）の通知設定</th>
            <td>
              <el-radio-group v-model="userData.affiliateAchievementsNotification">
                <el-radio :label="'1'">通知する</el-radio>
                <el-radio :label="'0'">通知しない</el-radio>
              </el-radio-group>
              <ValidationErrorMessages :errorMessageList="validationErrorData.affiliateAchievementsNotification" />
            </td>
          </tr>
          <tr>
            <th>通知先のアドレス設定</th>
            <td>
              <el-input v-model="userData.affiliateAchievementsNotificationEmail" type="email" />
              <ValidationErrorMessages :errorMessageList="validationErrorData.affiliateAchievementsNotificationEmail" />
            </td>
          </tr>
          <tr>
            <th>報酬確定の通知設定</th>
            <td>
              <el-radio-group v-model="userData.affiliateSettlementsNotification">
                <el-radio :label="'1'">通知する</el-radio>
                <el-radio :label="'0'">通知しない</el-radio>
              </el-radio-group>
              <ValidationErrorMessages :errorMessageList="validationErrorData.affiliateSettlementsNotification" />
            </td>
          </tr>
          <tr>
            <th>通知先のアドレス設定</th>
            <td>
              <el-input v-model="userData.affiliateSettlementsNotificationEmail" type="email" />
              <ValidationErrorMessages :errorMessageList="validationErrorData.affiliateSettlementsNotificationEmail" />
            </td>
          </tr>
        </table>
        <div class="register-button-cover">
          <el-button @click="registerConfigData" type="primary">更新</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ValidationErrorMessages from "@/components/Ui/ValidationErrorMessages.vue";

export default {
  name: "AffiliateNoticeNotificationConfig",
  components: {
    ValidationErrorMessages,
  },
  props: {},
  data() {
    return {
      // 
      userData: {
        affiliateAchievementsNotification: "",
        affiliateAchievementsNotificationEmail: "",
        affiliateSettlementsNotification: "",
        affiliateSettlementsNotificationEmail: "",
      },

      // 
      validationErrorData: {
        affiliateAchievementsNotification: [],
        affiliateAchievementsNotificationEmail: [],
        affiliateSettlementsNotification: [],
        affiliateSettlementsNotificationEmail: [],
      }
    };
  },
  computed: {
    ...mapGetters(["rt", "apiErrorMessage"]),
  },
  watch: {},
  created() {
    this.userData = JSON.parse(JSON.stringify(this.$store.getters["userData"]));
  },
  methods: {
    registerConfigData() {
      // 
      const affiliateAchievementsNotification = this.userData.affiliateAchievementsNotification;
      const affiliateAchievementsNotificationEmail = this.userData.affiliateAchievementsNotificationEmail;
      const affiliateSettlementsNotification = this.userData.affiliateSettlementsNotification;
      const affiliateSettlementsNotificationEmail = this.userData.affiliateSettlementsNotificationEmail;

      // 
      let params = new URLSearchParams();
      params.append("affiliate_achievements_notification", affiliateAchievementsNotification);
      params.append("affiliate_achievements_notification_email", affiliateAchievementsNotificationEmail);
      params.append("affiliate_settlements_notification", affiliateSettlementsNotification);
      params.append("affiliate_settlements_notification_email", affiliateSettlementsNotificationEmail);
      this.$axios
        .post(`${this.rt}/l/api/user/register-affiliate-notification-settings`, params)
        .then((response) => {
          console.log(response);
          if (response.data.status === 200) {
            this.$store.dispatch("setUserData");
            this.$router.go(-1);
          } else if (response.data.status === 400) {
            this.validationErrorData = response.data.validationErrorData;
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push('/login');
          } else {
            alert(this.apiErrorMessage);
          }
          return;
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
table.af-pop {
  tr {
    th {
      width: 45%;
      height: 40px;

      @media screen and (max-width: 768px) {
        font-size: 12px;
      }
    }

    td {
      text-align: left;
    }
  }
}
</style>
